<template>
    <div :class="'btn-group drop_mn ' + (expanded ? 'show' : '')" v-clickoutside="close">
        <Button type="button" class="dropdown-toggle" data-cy="opciones" @click.prevent="toggle()">
            OPCIONES
        </Button>
        <div :class="'dropdown-menu ' + (expanded ? 'show' : '')">
            <template v-for="(option, index) in options">
                <div v-if="option.visible !== false" :key="index">
                    <template v-if="option.type === 'action'">
                        <button class="dropdown-item" @click="closeAndTrigger(option.action)">
                            {{option.label}}
                        </button>
                    </template>
                    <template v-else-if="option.type === 'url'">
                        <a class="dropdown-item" :href="option.url" target="_blank">
                            {{option.label}}
                        </a>
                    </template>
                    <template v-else>
                        <router-link v-if="option.to" :to="option.to" class="dropdown-item">
                            {{option.label}}
                        </router-link>
                    </template>
                </div>
            </template>
        </div>
    </div>
</template>


<script>
    export default {
        props: {
            options: Array
        },
        data() {
            return {
                expanded: false
            }
        },
        methods: {
            toggle() {
                this.$emit(this.expanded ? 'close' : 'open', this);
                this.expanded = !this.expanded;
            },
            close() {
                this.expanded = false;
            },
            closeAndTrigger(func) {
                this.expanded = false;
                func();
            }
        },
        directives: {
            clickoutside: {
                bind: function(element, binding, vnode) {
                    element.clickOutsideEvent = function(event) {
                        if(!(element === event.target || element.contains(event.target))) {
                            vnode.context[binding.expression](event);
                        }
                    };
                    document.body.addEventListener('click', element.clickOutsideEvent)
                },
                unbind: function(element) {
                    document.body.removeEventListener('click', element.clickOutsideEvent)
                }
            }
        }
    }
</script>

<style scoped>
    .dropdown-item {
        text-transform: uppercase;
    }

    .drop_mn {
        position: relative;
    }

    .drop_mn .dropdown-menu {
        top: 0;
        right: 100%;
        left: auto;
        margin-top: 0;
        margin-right: 0.125rem;
    }

    @media (max-width: 768px) {
        .drop_mn .dropdown-menu {
            top: 100%;
            right: auto !important;
            left: 0 !important;
            margin-top: 0;
            margin-right: 0.125rem;
        }
    }
</style>